import { isIOSocialInAppBrowser } from './inAppBrowser'

/**
 * 受限 WebView（如部分 FB IAB）可能禁用 Proxy；此处仅用普通对象预置常见 handler 名，
 * 避免 `window.webkit.messageHandlers.xxx` 在未注入时为 undefined 导致崩溃。
 * 若线上 Sentry 仍出现新的 handler 名，可在此数组末尾追加。
 */
const WEBKIT_MESSAGE_HANDLER_NOOP_NAMES = [
  'postMessage',
  'cordova',
  'cordova_iab',
  '_cordovaNative',
  'invoke',
  'external',
  'webkit',
  'ios',
  'native',
  'app',
  'android',
  'facebook',
  'Facebook',
  'fb',
  'FB',
  'fbsdk',
  'FBSSDK',
  'fbNative',
  'fb_ssp',
  'messenger',
  'instagram',
  'tracking',
  'analytics',
  'logEvent',
  'sendEvent',
  'metrics',
  'bridge',
  'JavascriptBridge',
  'WVJBInterface',
  '__fbBatchedBridge',
  'ReactNativeWebView',
  'ReactNative',
  'RCTLog',
  'TikTok',
  'Bytedance',
  'bytedance',
  'adjust',
  'Adjust',
  'firebase',
  'Firestore',
]

const createNoopMessageHandlersRecord = () => {
  const o = Object.create(null)
  for (const name of WEBKIT_MESSAGE_HANDLER_NOOP_NAMES) {
    o[name] = {
      postMessage() {
        return false
      },
    }
  }
  return o
}

export function installWebkitBridgeGuard() {
  if (typeof window === 'undefined') return

  const enabled = import.meta.env.VITE_WEBKIT_BRIDGE_GUARD_DISABLED === '1' ? false : true
  if (!enabled) return
  if (!isIOSocialInAppBrowser()) return

  const wk = window.webkit
  if (wk?.messageHandlers) return

  const nextWebkit = wk && typeof wk === 'object' ? wk : {}
  nextWebkit.messageHandlers = createNoopMessageHandlersRecord()
  window.webkit = nextWebkit
}
